import React from 'react';

import Close from '@icons/Close.svg';

import { Button } from '@components/Button';
import { Header } from '@components/Common';
import { ViewSchoolModalSection } from '@components/Shifts/components';

import { ButtonConfig, ModalProps } from './interfaces';

import {
  Backdrop,
  ButtonsContainer,
  CloseButton,
  Divider,
  ModalContainer,
  TitleContainer,
} from './styles';

/**
 * Modal component that can be displayed in regular or full-screen mode.
 * @param props.fullScreen - When true, the modal takes up the entire viewport and adds a divider below the title
 */
export const Modal = ({
  title,
  isOpen,
  onClose,
  children,
  buttons,
  fullScreen,
  viewSchool = false,
  substituteName,
  onSubstituteNameChange,
  bringSubstitute,
  onBringSubstituteChange,
  triggerValidation,
  selectedShift,
}: ModalProps) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    // Only close if clicking the backdrop itself, not the modal content
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <Backdrop onClick={handleBackdropClick}>
      <ModalContainer $fullScreen={fullScreen}>
        {title && (
          <TitleContainer>
            <Header>{title}</Header>
            <CloseButton onClick={onClose}>
              <Close />
            </CloseButton>
          </TitleContainer>
        )}
        {fullScreen && <Divider />}
        {children}
        {viewSchool && (
          <ViewSchoolModalSection
            substituteName={substituteName || ''}
            onSubstituteNameChange={onSubstituteNameChange || (() => {})}
            bringSubstitute={bringSubstitute}
            onBringSubstituteChange={onBringSubstituteChange}
            triggerValidation={triggerValidation}
            listingId={selectedShift?.listing_id}
          />
        )}

        {buttons && buttons.length > 0 && (
          <ButtonsContainer>
            {buttons.map((button: ButtonConfig) => (
              <Button
                key={button.label}
                label={button.label}
                onClick={button.onClick}
                variant={button.variant}
                icon={button.icon}
              />
            ))}
          </ButtonsContainer>
        )}
      </ModalContainer>
    </Backdrop>
  );
};
